// Array to store all sections
const sections = $('.section');
let currentSectionIndex = 0; // Start with the first section

// Function to scroll to a specific section
function scrollToSection(index) {
    if (index >= 0 && index < sections.length) {
        currentSectionIndex = index;
        $('html, body').animate({
            scrollTop: $(sections[index]).offset().top
        }, 800); // 800ms for smooth scroll
    }
}

// Listen for scroll events
$(window).on('wheel', function (event) {
    if ($('html, body').is(':animated')) return; // Prevent double triggering during animation

    if (event.originalEvent.deltaY > 0) {
        // Scroll down
        scrollToSection(currentSectionIndex + 1);
    } else {
        // Scroll up
        scrollToSection(currentSectionIndex - 1);
    }
});



// scroll nappe details Start

let lastScrollTop = 0; // Track last scroll position
const animatedSections = $('.product_details');

// Function to check if an element is in view
function isInView(element) {
    const rect = element[0].getBoundingClientRect();
    return rect.top <= window.innerHeight && rect.bottom >= 0;
}

// Function to handle scroll event
function handleScroll() {
    const scrollTop = $(window).scrollTop();

    if (scrollTop > lastScrollTop) {
        // Only animate on scrolling down
        animatedSections.each(function () {
            const section = $(this);

            // Check if the section is in view and not yet animated
            if (isInView(section) && !section.hasClass('visible')) {
                section.addClass('visible');
            }
        });
    }

    lastScrollTop = scrollTop; // Update last scroll position
}

// Attach scroll event listener
$(window).on('scroll', handleScroll);

// scroll nappe details End